<div class="grid grid-cols-12 gap-6 w-full">
  <div *ngFor="let box of boxes" class="col-span-12 lg:col-span-3">
    <div class="box overflow-hidden h-full flex flex-col">
      <div class="box-header justify-between">
        <div class="box-title">
          {{ box.title }}
        </div>
        <span [class]="getStatusBadgeClass(box.status)">{{ box.status }}</span>
      </div>

      <div class="box-body !p-0 flex-1 flex flex-col">
        <!-- Loading -->
        <div *ngIf="box.loading" class="flex items-center justify-center p-8">
          <app-loading-spinner message="Carregando processos..." />
        </div>

        <!-- Error -->
        <div *ngIf="box.error && !box.loading" class="flex items-center justify-center p-8">
          <div class="text-center text-danger">
            <div class="flex items-center justify-center gap-2 mb-4">
              <i class="ri-error-warning-line text-xl"></i>
              <p class="!mt-1">Erro ao carregar processos</p>
            </div>
            <button class="ti-btn ti-btn-primary-full !py-1 !px-2 ti-btn-wave" (click)="retry(box.status)">
              <i class="ri-refresh-line"></i>
              Tentar Novamente
            </button>
          </div>
        </div>

        <!-- List -->
        <ul *ngIf="!box.loading && !box.error && box.processes.length > 0" class="list-group list-group-flush flex-1">
          <li
            *ngFor="let process of box.processes; trackBy: trackByProcessId"
            class="list-group-item !border-0 p-0"
          >
            <a
              class="block w-full px-4 py-3 hover:bg-gray-50 dark:hover:bg-white/5 transition cursor-pointer"
              [routerLink]="['/admin/groups/list']"
              [queryParams]="{ process_id: process.id, page: 1, per_page: 12 }"
            >
              <p class="mb-0 font-semibold">{{ process.name | truncate:50 }}</p>
              <p class="text-[0.75rem] text-[#8c9097] dark:text-white/50 mb-0">{{ process.protocol }}</p>
            </a>
          </li>
        </ul>

        <!-- Empty -->
        <div *ngIf="!box.loading && !box.error && box.processes.length === 0" class="flex-1 flex items-center justify-center p-8">
          <div class="text-center text-gray-500">
            <i class="bi bi-inbox text-4xl mb-3 block"></i>
            <p class="font-semibold text-sm mb-1">Nenhum processo encontrado</p>
            <p class="text-xs">Não há processos para exibir.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
